/**
 * Life-domain categories for optional Quick Clarity actions.
 * Decision-journal domains — not mood or wellness scores.
 */

export const ACTION_CATEGORY_KEYS = [
  "health",
  "wealth",
  "job",
  "social",
  "personal_development",
  "relationship"
];

export const ACTION_CATEGORIES = {
  health: {
    key: "health",
    label: "Health",
    mark: "H"
  },
  wealth: {
    key: "wealth",
    label: "Wealth",
    mark: "W"
  },
  job: {
    key: "job",
    label: "Job",
    mark: "J"
  },
  social: {
    key: "social",
    label: "Social",
    mark: "S"
  },
  personal_development: {
    key: "personal_development",
    label: "Personal Development",
    mark: "P"
  },
  relationship: {
    key: "relationship",
    label: "Relationship",
    mark: "R"
  }
};

/** Map legacy / alternate labels onto current keys. */
const CATEGORY_ALIASES = {
  fitness: "health",
  personal: "personal_development",
  "personal-development": "personal_development",
  personaldevelopment: "personal_development",
  relationships: "relationship"
};

export function canonicalActionCategory(value) {
  const raw = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  if (ACTION_CATEGORIES[raw]) return raw;
  if (CATEGORY_ALIASES[raw]) return CATEGORY_ALIASES[raw];
  return "job";
}

export function getActionCategoryMeta(value) {
  const key = canonicalActionCategory(value);
  return ACTION_CATEGORIES[key];
}

/** Lightweight heuristic when older actions have no category. */
export function inferActionCategory(text) {
  const t = String(text || "").toLowerCase();
  if (/\b(partner|spouse|boyfriend|girlfriend|marriage|relationship|dating)\b/.test(t)) {
    return "relationship";
  }
  if (/\b(friend|friends|social|party|gathering|community|network)\b/.test(t)) return "social";
  if (/\b(learn|course|skill|read|practice|habit|grow|develop|journal)\b/.test(t)) {
    return "personal_development";
  }
  if (/\b(workout|gym|run|exercise|train|steps|fitness|sleep|doctor|diet|nutrition|health|meal)\b/.test(t)) {
    return "health";
  }
  if (/\b(money|budget|invest|invoice|pay|salary|finance|wealth)\b/.test(t)) return "wealth";
  if (/\b(work|job|boss|meeting|product|feature|client|career|code)\b/.test(t)) return "job";
  return "job";
}
